import { fetchFromNewApi } from '~/services/Http';

export const getEmployeesData = async () => {
  return fetchFromNewApi('/myTeamTable', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((r) => r.json());
};
